// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Zy-z","giftOrPromoSelector":"_y-z","disabled":"az-z","subTitle":"bz-z","selectShipAddressMessage":"cz-z","changePayment":"dz-z"};